import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import config from 'configs';
import { unit } from '@kambria/kambria-util';
import util from 'helpers/utils.lib';
import { ethTransferToken } from 'modules/kat.reducer';

import { Button } from '@kambria/kambria-lego';


class CoreTransfer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      to: props.to,
      amount: props.amount,
      txId: null,
      error: null
    }
  }

  onTo = (e) => {
    this.setState({ to: e.target.value });
  }

  onAmount = (e) => {
    this.setState({ amount: e.target.value });
  }

  onTransfer = () => {
    this.props.ethTransferToken(this.state.to, unit.kat2WKAT(this.state.amount)).then(txId => {
      this.setState({ txId: txId, error: null });
    }).catch(er => {
      this.setState({ txId: null, error: er });
    });
  }

  handleButton = () => {
    if (this.state.txId) return <Button disabled type="primary" size="sm" customStyle={{ "height": "40px" }}>Transfer</Button>
    if (this.state.error) return <Button type="primary" size="sm" customStyle={{ "height": "40px" }} onClick={this.onTransfer}>Retry</Button>
    return <Button type="primary" size="sm" customStyle={{ "height": "40px" }} onClick={this.onTransfer}>Transfer</Button>
  }

  render() {
    return (
      <tbody>
        <tr>
          <td width="50%" className="pt-4">Target Ethereum Address</td>
          <td width="25%" className="pt-4">Value of {config.eth.TOKEN.UNIT}</td>
          <td width="25%" className="pt-4">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <input type="text" className="form-control w-100" onChange={this.onTo} value={this.state.to} />
          </td>
          <td>
            <input type="text" className="form-control w-100" onChange={this.onAmount} value={this.state.amount} />
          </td>
          <td>
            {this.handleButton()}
          </td>
        </tr>
        {this.state.txId ? <tr>
          <td className="result success pr-0" width="30%">Transaction Submitted.</td>
          <td className="pr-0" width="40%">
            <Button type="primary" size="sm" onClick={() => util.viewEtherscan(this.state.txId)}>View EtherScan</Button>
          </td>
        </tr> : null}
        {this.state.error ? <tr>
          <td className="result fail pr-0" width="30%">Transfer Failed!</td>
        </tr> : null}
      </tbody>
    );
  }
}

const mapStateToProps = state => ({
  kat: state.kat
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ethTransferToken
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoreTransfer);